import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { OrderPackageAggregateBusinessIdPutRequest } from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 発注単位を更新するユースケース
 */
export class PutOrderPackageUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 発注単位を更新する
   * @param aggregateBusinessId - 集計ID
   * @param orderPackage - 発注単位
   */
  public async Execute(aggregateBusinessId: string, orderPackage: number): Promise<INetworkResult<void, Error>> {
    const request: OrderPackageAggregateBusinessIdPutRequest = {
      orderPackage: orderPackage,
    };
    try {
      const result = await this.repository.putOrderPackage(aggregateBusinessId, request);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: undefined,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
